import { Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { ButtonCompo } from "../../components/Comman/Button";
import { withRouter } from "../../components/withRouter";
import {
  areYouSureMsg,
  excelExportedSuccessfullyMsg,
  savemsg,
  saveWarningMsg,
  serverMsg,
} from "../../config/messageconstant";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadF } from "../PDF/PDFDownload";
import ImportRuWiseTargetPopUp from "./components/ImportRuWiseTargetPopUp";
import RuWiseTargetTable from "./components/RuWiseTargetTable";
import { RU_TARGET_IMPORT_API } from "./constants/apiPaths";
import { tableHeaderButtonStyles } from "./styles/importPopupStyles";
import { hasValidationErrors } from "./utils/validationHelpers";

class RuWiseTargetMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: "",
      importPopUpFlag: false,
      validatedProductList: [],
      hasErrorRow: false,
    };
  }

  onClickOfExport = async () => {
    const { showLoador, showNotification } = this.props;

    showLoador({ loador: true });
    try {
      const response = await downloadF({
        isGet: true,
        url: RU_TARGET_IMPORT_API.exportExcel,
        ext: "xls",
        openNewTab: false,
        isShowSalesPersonName: true,
        reportName: "RU Wise Target",
      });

      if (!response) {
        showNotification({ msg: serverMsg, severity: "error" });
      } else {
        showNotification({ msg: excelExportedSuccessfullyMsg });
      }
    } finally {
      showLoador({ loador: false });
    }
  };

  onClickOfImport = () => {
    this.setState({ importPopUpFlag: true });
  };

  importPopUpClose = () => {
    this.setState({ importPopUpFlag: false });
  };

  onSearchBox = (e) => {
    this.setState({ searchValue: e.target.value });
  };

  dataMethod = (dataObj = []) => {
    this.setState({
      validatedProductList: dataObj,
      hasErrorRow: hasValidationErrors(dataObj),
    });
  };

  onSubmit = () => {
    const { showLoador, showNotification } = this.props;
    const { validatedProductList } = this.state;

    swal({
      title: areYouSureMsg,
      text: saveWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willSave) => {
      if (!willSave) return;

      showLoador({ loador: true });
      try {
        const { success } = await apiPost({
          url: RU_TARGET_IMPORT_API.save,
          postBody: validatedProductList,
        });

        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
          return;
        }

        showNotification({ msg: savemsg });
        setTimeout(() => {
          window.location.reload();
        }, 1250);
      } finally {
        showLoador({ loador: false });
      }
    });
  };

  render() {
    const {
      importPopUpFlag,
      validatedProductList,
      hasErrorRow,
      searchValue,
    } = this.state;

    return (
      <>
        <Paper sx={tableHeaderButtonStyles.paper} elevation={5}>
          <RuWiseTargetTable
            onClickOfExport={this.onClickOfExport}
            onClickOfImport={this.onClickOfImport}
            searchValue={searchValue}
            onSearchBox={this.onSearchBox}
            validatedProductList={validatedProductList}
          />

          {validatedProductList.length !== 0 && !hasErrorRow && (
            <Grid
              item
              sm={12}
              xs={12}
              md={12}
              lg={12}
              rowSpacing={2}
              columnSpacing={{ xs: 12, sm: 6, md: 1 }}
              container
              justifyContent="right"
              sx={{ marginTop: 3 }}
            >
              <ButtonCompo
                size="medium"
                type="submit"
                variant="contained"
                name="Submit"
                onClick={this.onSubmit}
              />
            </Grid>
          )}
        </Paper>

        {importPopUpFlag && (
          <ImportRuWiseTargetPopUp
            open={importPopUpFlag}
            handleCloses={this.importPopUpClose}
            dataMethod={this.dataMethod}
          />
        )}
      </>
    );
  }
}

const mapDispatchToProps = {
  showLoador,
  showNotification,
};

export default compose(
  withRouter,
  connect(null, mapDispatchToProps)
)(RuWiseTargetMain);
